import { useCustomToast } from '@elkaso-app/web-design';
import { useSignInCheckApi } from 'apis/auth/use-sign-in-check-api';
import { LoginType } from '../index';
import { useSendOtp } from './use-send-otp';

export const useSignInCheck = () => {
  const toast = useCustomToast();

  const { isLoading: isLoadingSignInCheck, mutateAsync: signInCheckApi } = useSignInCheckApi();
  const { isLoading: isLoadingSendOtp, onSendOtp } = useSendOtp();

  const onSignInCheck = async (loginType: LoginType, loginValue: string) => {
    const variables = {
      body: {
        [loginType]: loginValue,
      },
    };

    const { entityType, next } = await signInCheckApi(variables);

    if (entityType === 'supplier') {
      return toast({
        description: "This user isn't a restaurant user.",
        status: 'error',
      });
    }

    if (next === 'login') {
      return onSendOtp(loginType, loginValue);
    }

    if (next === 'register') {
      return window.open('https://www.kaso.ai/#email-form', '_blank', 'noreferrer');
    }

    if (next === 'pending') {
      return toast({
        description: "Current platform isn't available to the user. Please contact customer support ",
        status: 'error',
      });
    }

    if (next === 'unverified') {
      return toast({
        description: 'Unverified user! Please contact customer support.',
        status: 'error',
      });
    }
  };

  return {
    onSignInCheck,
    isLoading: isLoadingSignInCheck || isLoadingSendOtp,
  };
};
